export enum LoginFlow {
	GENERAL = 'GENERAL',
	SSO = 'SSO',
	EXTERNAL = 'EXTERNAL'
}

